export const DEFAULT_ITEMS_PER_PAGE = 10;
export const DEFAULT_PAGE_NUMBER = 1;
